import SupplierMessageList from './List'
import SupplierMessageCreate from './Create'

export default {
  list: SupplierMessageList,
  create: SupplierMessageCreate
}
